// frontend/src/api/users.js
import { apiClient } from './index';

const usersApi = {
  getAllUsersAdmin: async () => {
    return await apiClient.get('/users/admin/all');
  },

  /**
   * Update user roles, territory, and permissions
   */
  updateUserRoles: async (userId, roles, managedStates = [], managedLgas = [], managedZones = [], permissions = {}) => {
    return await apiClient.put(`/users/admin/${userId}/roles`, { 
        roles,
        managed_states: managedStates,
        managed_lgas: managedLgas,
        managed_zones: managedZones,
        permissions: permissions // <--- NEW
    });
  },
  
  registerCustomerAdmin: async (data) => {
    return await apiClient.post('/users/admin/register', data);
  },

  getUserHistory: async (userId) => {
    return await apiClient.get(`/users/admin/${userId}/history`);
  },

  toggleUserBan: async (userId, action) => {
    return await apiClient.put(`/users/admin/${userId}/status`, { action });
  },

  resetUserPassword: async (userId, newPassword) => {
    return await apiClient.put(`/users/admin/${userId}/password`, { new_password: newPassword });
  }
};

export { usersApi };